import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dReadOnly from "../Restaumatic.Form.ReadOnly/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dSite$dComponents$dCrossSelling from "../Restaumatic.Site.Components.CrossSelling/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dModals from "../Restaumatic.Site.Modals/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dBootstrap$dModal from "../Specular.Bootstrap.Modal/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
const content = v => modalRef => {
  const $0 = v.crossSelling;
  const $1 = v.onFinish;
  const $2 = Effect$dAff._makeFiber(
    Effect$dAff.ffiUtil,
    Effect$dAff._bind(Effect$dAff._liftEffect(Restaumatic$dSite$dModals.setNextModalShouldReplaceHash))(() => Effect$dAff._bind(Specular$dFRP$dBase.readDynamic(Effect$dAff.monadEffectAff)(modalRef._1))(modalNode => Effect$dAff._bind((() => {
      const $2 = Effect$dAff._pure();
      if (modalNode.tag === "Nothing") { return $2; }
      if (modalNode.tag === "Just") { return Effect$dAff.applyAff.apply(Effect$dAff._map(v$1 => x => x)(Specular$dBootstrap$dModal.hideModalBs5(modalNode._1)))($2); }
      $runtime.fail();
    })())(() => Effect$dAff._liftEffect($1))))
  );
  return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("modal-header")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
    Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $3 = {};
      $3.type = "button";
      return $3;
    })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $3 = {};
      $3.class = "close";
      return $3;
    })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $3 = {};
      $3["data-bs-dismiss"] = "modal";
      return $3;
    })())((() => {
      const $3 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.modal.close), {});
      return (() => {
        const $4 = {};
        $4["aria-label"] = $3;
        return $4;
      })();
    })()))))
  ])(Specular$dDom$dElement.el("span")([
    Specular$dDom$dElement.attrs((() => {
      const $3 = {};
      $3["aria-hidden"] = "true";
      return $3;
    })())
  ])(Specular$dDom$dElement.text("×"))))(() => Specular$dDom$dElement.el("h2")([Specular$dDom$dElement.class_("modal-title"), Specular$dDom$dElement.class_("h3")])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.crossup.title),
    {}
  ))))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["modal-body"])])(Restaumatic$dSite$dComponents$dCrossSelling.display()()({
    field: $0,
    inModal: true
  })))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["modal-footer", "modal-footer--sticky"])])(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["modal-footer__actions", "modal-footer__actions--ssm-regular"])
  ])(Specular$dDom$dElement.el("button")([
    Specular$dDom$dElement.class_("btn btn-primary"),
    Specular$dDom$dElement.attr("type")("button"),
    Specular$dDom$dElement.onClick_(() => {
      const fiber = $2();
      fiber.run();
    })
  ])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(v1 => {
    if (v1 === 0) { return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.generic.next), {}); }
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.creator.add_to_cart), {}) + " (" + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v1) + ")";
  })(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(0)($0.total))))))));
};
const init = /* #__PURE__ */ Specular$dInternal$dRIO.bindImpl(/* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Data$dMaybe.Nothing))(currentRequest => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Data$dMaybe.Nothing))(v => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el$p("div")([
  Specular$dDom$dElement.classes(["modal", "fade", "js-popover-container"]),
  Specular$dDom$dElement.attr("id")("cross-selling"),
  Specular$dDom$dElement.attr("role")("dialog"),
  Specular$dDom$dElement.attr("tabindex")("-1"),
  Specular$dDom$dElement.classWhenD(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.isNothing)(currentRequest._1))("js-modal--uninitialized")
])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["modal-dialog"])])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("modal-content")])(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(currentRequest._1)((() => {
  const $0 = Specular$dInternal$dRIO.pureImpl();
  return v1 => {
    if (v1.tag === "Nothing") { return $0; }
    if (v1.tag === "Just") { return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x => x)(content(v1._1)(v)))($0); }
    $runtime.fail();
  };
})())))))(v1 => {
  const $0 = v1._1;
  return Specular$dInternal$dRIO.bindImpl(v._2(_old => Data$dMaybe.$Maybe("Just", $0)))(() => Specular$dInternal$dRIO.pureImpl({
    open: request => {
      const $1 = currentRequest._2(_old => Data$dMaybe.$Maybe("Just", request));
      return () => {
        $1();
        const fiber = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, Specular$dBootstrap$dModal.showModalBs5($0))();
        fiber.run();
      };
    }
  }));
})));
export {content, init};
